import axios from 'axios'

export default {
  processStep: (data) => {
    return axios.post(process.env.VUE_APP_API_PROCESS_STEP, data)
  },
  getUserProfile: () => {
    return axios.get(process.env.VUE_APP_API_USER_PROFILE)
  },
  dataStep: (processId) => {
    return axios.get(`${process.env.VUE_APP_API_DATA_STEP}?processId=${processId}`)
  },
  status: (processId) => {
    return axios.get(process.env.VUE_APP_API_STATUS + `?processId=${processId}`)
  },
  logEventToKafka: (event) => {
    return axios.post(process.env.VUE_APP_API_LOG_EVENT_KAFKA, event)
  },
  getSettings: () => {
    return axios.get(process.env.VUE_APP_API_SETTINGS)
  }
}
